export default __webpack_public_path__ + "static/media/marauders-map-v3-05-02.ac6075e8.jpg";